export default __webpack_public_path__ + "static/media/japan-circle-flag.d3bffa34.png";